import {observable, action} from "mobx";

class CampaignStore {
    @observable campaign_id = null;
    @observable formHeading = null;
    @observable spinButtonText = null;
    @observable formEmailPlaceholder = null;
    @observable campaignOptions = null;
    @observable triggerLabel = null;
    @observable triggerPosition = null;
    @observable headerBackgroundColor = null;
    @observable headerColor = null;
    @observable submitBackgroundColor = null;
    @observable submitColor = null;
    @observable hideAppExpirationDays = null;
    @observable submitFormExpirationDays = null;
    @observable campaignType = null;
    @observable facebookPageId = null;
    @observable circleMainColor = null;
    @observable circleLightenColor = null;
    @observable formTheme = null;
    @observable triggerTheme = null;
    @observable scarCityBarIsActive = null;
    @observable scarCityBarText = null;
    @observable scarCityBarCountdownText = null;
    @observable scarCityBarCountdownTime = null;
    @observable scarCityBarPosition = null;
    @observable scarCityBarBgColor = null;
    @observable addCheckboxToGDPRCompliance = false;
    @observable GDPRComplianceIsActive = false;
    @observable GDPRComplianceText = null;
    @observable isPhoneNumberCampaign = false;
    autoOpenForNewVisitors = null;
    autoOpenDelaySeconds = null;

    @action
    getCampaignFromJson(json) {
        this.formHeading = json.form_heading;
        this.spinButtonText = json.spin_button_text;
        this.formEmailPlaceholder = json.form_email_placeholder;
        this.campaignOptions = json.options;
        this.triggerLabel = json.trigger_label;
        this.triggerPosition = json.trigger_position;
        this.campaign_id = json.id;
        this.headerBackgroundColor = json.header_background_color;
        this.headerColor = json.header_color;
        this.submitBackgroundColor = json.submit_background_color;
        this.submitColor = json.submit_color;
        this.hideAppExpirationDays = json.hide_app_expiration_days;
        this.submitFormExpirationDays = json.submit_form_expiration_days;
        this.campaignType = json.campaign_type;
        this.facebookPageId = json.facebook_page_id;
        this.circleMainColor = json.circle_main_color;
        this.circleLightenColor = json.circle_lighten_color;
        this.autoOpenForNewVisitors = json.auto_open_for_new_visitors;
        this.autoOpenDelaySeconds = json.auto_open_delay_seconds;
        this.formTheme = json.form_theme;
        this.triggerTheme = json.trigger_theme;
        this.scarCityBarIsActive = json.scar_city_bar_is_active;
        this.scarCityBarText = json.scar_city_bar_text;
        this.scarCityBarCountdownText = json.scar_city_bar_countdown_text;
        this.scarCityBarPosition = json.scar_city_bar_position;
        this.scarCityBarCountdownTime = json.scar_city_bar_countdown_time;
        this.scarCityBarBgColor = json.scar_city_bar_bg_color;
        this.GDPRComplianceIsActive = json.gdpr_compliance_is_active;
        this.addCheckboxToGDPRCompliance = json.add_checkbox_to_gdpr_compliance;
        this.GDPRComplianceText = json.gdpr_compliance_text;
        this.isPhoneNumberCampaign = json.is_phone_number_campaign;
    }

    setPopUpColors(el) {
        el.style.setProperty('--kol-header-bg', campaignStore.headerBackgroundColor);
        el.style.setProperty('--kol-submit-bg', campaignStore.submitBackgroundColor);
        el.style.setProperty('--kol-header-color', campaignStore.headerColor);
        el.style.setProperty('--kol-submit-color', campaignStore.submitColor);
        el.style.setProperty('--kol-circle-main-color', campaignStore.circleMainColor);
        el.style.setProperty('--kol-circle-lighten-color', campaignStore.circleLightenColor);
        this.setCircleTextColor(el)
    }

    setTriggerColors(el) {
        el.style.setProperty('--kol-circle-main-color', campaignStore.circleMainColor);
        el.style.setProperty('--kol-circle-lighten-color', campaignStore.circleLightenColor);
        this.setCircleTextColor(el)
    }

    setScarCityBarColors(el){
        el.style.setProperty('--kol-scarcity-bar-bg', this.scarCityBarBgColor);
    }

    setCircleTextColor(el) {
        let r = 0, g = 0, b = 0;
        const color = campaignStore.circleMainColor;
        if (color.length === 4) {
            r = parseInt(color[1] + color[1], 16);
            g = parseInt(color[2] + color[2], 16);
            b = parseInt(color[3] + color[3], 16);
        } else if (color.length === 7) {
            r = parseInt(color[1] + color[2], 16);
            g = parseInt(color[3] + color[4], 16);
            b = parseInt(color[5] + color[6], 16);
        }

        // Вычисление восприятия яркости (perceived lightness)
        const perceivedLightness = (r * 0.2126 + g * 0.7152 + b * 0.0722) / 255;

        // Установка цвета текста в зависимости от яркости
        const threshold = 0.5;
        const textColor = perceivedLightness > threshold ? 'hsl(0, 0%, 0%)' : 'hsl(0, 0%, 100%)';

        el.style.setProperty('--kol-circle-text-red', r);
        el.style.setProperty('--kol-circle-text-green', g);
        el.style.setProperty('--kol-circle-text-blue', b);
        el.style.setProperty('--kol-sector-text-color', textColor);
    }

}

const campaignStore = new CampaignStore();
export default campaignStore;
